import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment'; 
import { HttpClient, HttpHeaders, HttpEvent, HttpEventType } from '@angular/common/http';

import { Observable, throwError, TimeoutError, Subject } from 'rxjs';
import { map, catchError, timeout, finalize } from 'rxjs/operators';
import { MainService } from '../main-service.service';
// import { Intercom } from 'ng-intercom';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { ToasterService } from '../toaster.service';
import { Intercom } from '@supy-io/ngx-intercom';
@Injectable({
  providedIn: 'root'
})
export class ProposalService {
  env: any = environment;
  public contractData = new Subject<any>();
  private patientData = new Subject<any>();
  private selectedPlan = new Subject<any>();
  private paymentData = new Subject<any>();
  private businessData = new Subject<any>();
  public currentLang = new Subject<any>();
  months: any = [];
  birthYears: any = [];
  newYears: any = [];
  dates: any = [];
  dob: any = {
    month: '',
    date: '',
    year: ''
  };
  token: any;
  headers: any = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' });
  timeoutError: any;
  fileName: any;
  constructor(
    public http: HttpClient,
    public mainService: MainService,
    public toasterService: ToasterService,
    public intercom: Intercom
  ) {
    // let api_url = localStorage.getItem('request_url');
    // this.env.request_url =  api_url ? api_url : environment.request_url;
  }
  // date formating change
  formatDateStringPromise(dateString) {
    console.log(dateString,">>>>>>");
    
    return new Promise((resolve, reject) => {
      if (!dateString) {
        reject("Date string is empty");
      }
      if (dateString.includes('/') || dateString.includes('-')) {
        const [month, year, day] = dateString.includes('/') ? dateString.split('/') : dateString.split('-');
        resolve(`${year}-${month}-${day}`);
      } else {
        const month = dateString.slice(0, 2)
        const day = dateString.slice(2, 4)
        const year = dateString.slice(4)
        resolve(`${year}-${month}-${day}`);
      }
    });
  }

  api(method: any, url: any, params: any, custom_url?: string, download = '') {
    let server_url = custom_url ? custom_url : this.env.request_url + url;
    let config = download == 'download' ? { headers: this.mainService.headers } : { headers: this.mainService.headers };
    if (method === 'post') {
      return this.http
        .post<any>(server_url, params, {
          headers: this.mainService.headers
        })
        .pipe(
          timeout(300000),
          map((data: any) => {
            return data;
          }),
          catchError((error: any) => {
            this.mainService.setLoader(false);
            this.toasterService.message(error.message, 3)
            if (error instanceof TimeoutError) {
              this.toasterService.message(
                'Server Timeout, Try after sometime.',
                3
              );
              return throwError({ error: 'Timeout Exception' });
            }
            return throwError(error);
          })
        );
    } else if (method === 'get') {
      return this.http
        .get<any>(server_url, config)
        .pipe(
          timeout(300000),
          map((data: any) => {
            return data;
          }),
          catchError((error: any) => {
            this.mainService.setLoader(false);
            this.toasterService.message('error', error.message)
            if (error instanceof TimeoutError) {
              this.toasterService.message(
                'Server Timeout, Try after sometime.',
                3
              );
              return throwError({ error: 'Timeout Exception' });
            }
            return throwError(error);
          })
        );
    }
  }
  // api(method: 'get' | 'post', url: string, params?: any, custom_url?: string) {
  //   const server_url = custom_url ? custom_url : this.env.request_url + url;

  //   const request$ =
  //     method === 'post'
  //       ? this.http.post<any>(server_url, params, { headers: this.mainService.headers })
  //       : this.http.get<any>(server_url, { headers: this.mainService.headers });

  //   return request$.pipe(
  //     timeout(300000),map((data: any) => {
  //           return data;
  //         }),
  //         catchError((error: any) => {
  //           this.mainService.setLoader(false);
  //           this.toasterService.message(error.message, 3)
  //           if (error instanceof TimeoutError) {
  //             this.toasterService.message(
  //               'Server Timeout, Try after sometime.',
  //               3
  //             );
  //             return throwError({ error: 'Timeout Exception' });
  //           }
  //           return throwError(error);
  //         })
  //       );
  //   } else if (method === 'get') {
  //     return this.http
  //       .get<any>(server_url, {
  //         headers: this.mainService.headers
  //         // responseType: 'blob' as 'json'
  //       })
  //       .pipe(
  //         timeout(300000),
  //         map((data: any) => {
  //           return data;
  //         }),
  //         catchError((error: any) => {
  //           this.mainService.setLoader(false);
  //           this.toasterService.message('error', error.message)
  //           if (error instanceof TimeoutError) {
  //             this.toasterService.message(
  //               'Server Timeout, Try after sometime.',
  //               3
  //             );
  //             return throwError({ error: 'Timeout Exception' });
  //           }
  //           return throwError(error);
  //         })
  //       );
  //   }
  // }
  // api(method: 'get' | 'post', url: string, params?: any, custom_url?: string) {
  //   const server_url = custom_url ? custom_url : this.env.request_url + url;

  //   const request$ =
  //     method === 'post'
  //       ? this.http.post<any>(server_url, params, { headers: this.mainService.headers })
  //       : this.http.get<any>(server_url, { headers: this.mainService.headers });

  //   return request$.pipe(
  //     timeout(300000),

  //     catchError((error: any) => {

  //       // ⛔ Network or server timeout
  //       if (error instanceof TimeoutError) {
  //         this.toasterService.message('Server Timeout, Try after sometime.', 3);
  //       }
  //       // ⛔ Backend sent error message
  //       else if (error?.error?.message) {
  //         this.toasterService.message(error.error.message, 3);
  //       }
  //       // ⛔ Unknown error
  //       else {
  //         this.toasterService.message('Server error. Please try again.', 3);
  //       }

  //       return throwError(() => error);
  //     }),

  //     finalize(() => {
  //       this.mainService.setLoader(false);   // 🔥 always stops loader
  //     })
  //   );
  // }


  formApi(method: any, url: any, params: any) {
    let server_url = this.env.request_url + url
    // if (url == 'practina/get_practina_intent_detail') {
    //   server_url = `http://localhost:3004/practina/get_practina_intent_detail`
    // }
    if (method === 'post') {
      return this.http
        .post<any>(server_url, params)
        .pipe(
          timeout(300000),
          map((data: any) => {
            return data;
          }),
          catchError((error: any) => {
            this.mainService.setLoader(false);
            this.toasterService.message('error', error.message)
            if (error instanceof TimeoutError) {
              this.toasterService.message(
                'Server Timeout, Try after sometime.',
                3
              );
              return throwError({ error: 'Timeout Exception' });
            }
            return throwError(error);
          })
        );
    }
  };

  downloadApi(url: any, data: any, view: any) {
    let config = { headers: this.headers, responseType: 'blob' as 'json', observe: 'response' as 'body' };
    let api_url = this.env.request_url;
    return this.http.post<any>(`${api_url}${url}`, this.mainService.urlParams(data),
      config)
      .pipe(
        timeout(300000),
        map((data: any) => {
          function extractFirstText(str) {
            const matches = str.match(/"(.*?)"/);
            return matches
              ? matches[1]
              : str;
          }
          let headers = data.headers.get('Content-Disposition');
          this.fileName = extractFirstText(headers);
          data = data.body;
          var blob = new Blob([data], { type: 'application/pdf' });
          var urlwindow = window.URL.createObjectURL(blob);
          if (view == 0) {
            var anchor = document.createElement("a");
            anchor.download = this.fileName;
            anchor.href = urlwindow;
            anchor.click();
          } else if (view == 1) {
            var pwa = window.open(urlwindow);
            if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
              alert("Please disable your browser's pop-up blocker and try again.");
            }
          }
          else if (view == 2) {
            var w = window.open(urlwindow, "", "width=800,height=800");
            if (!w || w.closed || typeof w.closed == 'undefined') {
              alert("Please disable your browser's pop-up blocker and try again.");
            }
            if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
              w.location.reload();
            }
            w.focus();
            w.print();
          }
        }),
        catchError((error: any) => {
          if (error instanceof TimeoutError) {
            if (!this.timeoutError) {
              this.timeoutError = true;
              this.toasterService.message('Request Timeout', 3)
            }
            return throwError({ error: 'Timeout Exception' });
          }
          if (error.status == 0) {
            if (!this.timeoutError) {
              this.toasterService.message('Unable to fetch data from server', 3);
            }
          }
          return throwError(error);
        })
      )
  }

  setToken(token: any) {
    this.token = token;
  }

  getToken() {
    return this.token;
  }

  sendData(data: any) {
    this.contractData.next(data);
  }

  getData() {
    return this.contractData.asObservable();
  }

  sendPaymentData(data: any) {
    this.paymentData.next(data);
    console.log(data)
  }

  getPaymentData() {
    return this.paymentData.asObservable();
  }

  setBusinessData(data: any) {
    this.businessData.next(data);
  }

  getBusinessData() {
    return this.businessData.asObservable();
  }

  setPatientData(data: any) {
    this.patientData.next(data);
  }

  getPatientUpdatedData() {
    return this.patientData.asObservable();
  }

  openIntercom() {
    this.mainService.setLoader(true);
    this.intercom.boot({
      app_id: environment.intercom_id,
    });
    this.intercom.show();
    this.intercom.onHide(() => {
      this.intercom.shutdown()
    });
    this.intercom.onShow(() => {
      this.mainService.setLoader(false);
    })
  }


  getDates() {
    for (let i = 0; i < 31; i++) {
      this.dates[i] = i + 1;
    }
    for (let j = 0; j < 12; j++) {
      // console.log(this.months[j]);
      this.months[j] = {
        month: '',
        month_name: ''
      };
      if (j + 1 === 1) {
        this.months[j].month_name = 'January';
      }
      if (j + 1 === 2) {
        this.months[j].month_name = 'February';
      }
      if (j + 1 === 3) {
        this.months[j].month_name = 'March';
      }
      if (j + 1 === 4) {
        this.months[j].month_name = 'April';
      }
      if (j + 1 === 5) {
        this.months[j].month_name = 'May';
      }
      if (j + 1 === 6) {
        this.months[j].month_name = 'June';
      }
      if (j + 1 === 7) {
        this.months[j].month_name = 'July';
      }
      if (j + 1 === 8) {
        this.months[j].month_name = 'August';
      }
      if (j + 1 === 9) {
        this.months[j].month_name = 'September';
      }
      if (j + 1 === 10) {
        this.months[j].month_name = 'October';
      }
      if (j + 1 === 11) {
        this.months[j].month_name = 'November';
      }
      if (j + 1 === 12) {
        this.months[j].month_name = 'December';
      }
      this.months[j].month = j + 1;
    }
    const d = new Date();
    const currentYear = d.getFullYear();
    for (let i = currentYear; i > 1900; i--) {
      this.birthYears[currentYear - i] = i;
    }
    for (let i = currentYear; i < 2100; i++) {
      this.newYears[i - currentYear] = i;
    }
    const dateObject = {
      months: this.months,
      dates: this.dates,
      birthYears: this.birthYears,
      newYears: this.newYears
    };
    return dateObject;
  }

  downloadContract(payToken, contractToken, pay_recurring) {
    let params = {
      pay_recurring_token: payToken,
      contract_patient_token: contractToken,
      device_info: JSON.stringify(this.mainService.device_info())
    };
    if (pay_recurring == 1) {
      delete params.contract_patient_token
    } else {
      delete params.pay_recurring_token
    }
    this.mainService.setLoader(true);
    this.downloadApi('download_contract_pdf', params, 0)
      .subscribe((data: any) => {
        console.log(data);
        this.mainService.setLoader(false);
      }, (error: any) => {
        console.log(error);
        this.mainService.setLoader(false);
      });
  }

  // tslint:disable-next-line:max-line-length
  choosePlanV2(contractToken: undefined, plan: { month: any; recurring_amount: any; interest_rate: any; interest_rate_to_show: any; contract_type: any; creditReportOption: boolean, is_scanner : 0}, index: Number, next: any, apiUrl?:any) {
    const params = {
      contract_token: contractToken,
      number_of_payments: plan.month,
      recurring_amount: plan.recurring_amount,
      interest_rate: plan.interest_rate,
    };
    if (plan?.is_scanner) {
      params['is_scanner'] = plan.is_scanner;
    }
    if (plan && plan.interest_rate_to_show) {
      params['interest_rate_to_show'] = plan.interest_rate_to_show;
    }
    let routeUrl = '/payment-details/';
    if (apiUrl == 'new_check_email_code_apf') {
      params['contract_type'] = plan.contract_type;
      if(plan && plan['mpp_id']) {
        routeUrl = '/payment-proposal/customer-detail/'
      } else {
        routeUrl = '/payment-link/customer-detail/'
      }
    } 
      let tilaData: { current_plan?: any; }|any;
      tilaData = {};
      tilaData.current_plan = JSON.stringify(plan);
      tilaData.credit_report_status = plan?.creditReportOption?1:0;
      localStorage.setItem('iframe_tila_data', JSON.stringify(tilaData));
    
    this.mainService.setLoader(true);
    this.api('post', 'choose_plan_v2', this.mainService.urlParams(params))
      .subscribe(
        (data: any) => {
          // this.mainService.setLoader(false);
          if (data.is_error) {
            if (data.flag === 585) {
              // this.openPendinOverdueModal();
            }
            // this.mainService.setLoader(true);
            this.mainService.router.navigate(['/invalid']);
          } else {
            const creditReportParam = plan?.creditReportOption ? 1 : 0;
            // this.mainService.setLoader(true);
            if (apiUrl == 'new_check_email_code_apf') {
              this.mainService.new_current_step = 2;
            }
            this.mainService.router.navigate(
  [routeUrl + contractToken],
  {
    queryParams: {
      plan: index,
      cr: creditReportParam
    },
    queryParamsHandling: 'merge'
  }
);
            if (next && (apiUrl != 'new_check_email_code_apf')) {
              this.check_email_code_apf({
                contract_token: contractToken,
                timezone: this.mainService.getCurrentTimezone()
              }, apiUrl);
            }
          }
        },
        (err: any) => {
          this.mainService.setLoader(false);
        }
      );
  }

  check_email_code_apf(params, url) {
    this
      .api('post', url , this.mainService.urlParams(params))
      .subscribe((data: any) => {
        if (data.is_error) {
          this.mainService.setLoader(true);
          // this.sendData(data);
        }
        if (data.split_request_data && data.split_request_data.length > 0) {
          if (Number(data.split_request_data[0].is_financed) === 0 || Number(data.split_request_data[0].is_req_expired) === 0) {
            this.sendData(data);
            this.mainService.setLoader(false);
            return;
          }

          this.sendData(data);
        } else if (!data.is_error) {
          this.sendData(data);
        }
        this.mainService.setLoader(false);
      });
  }

  emojiValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u;
      const value = control.value;
      if (value && emojiRegex.test(value)) {
        return { 'emoji': true }; // return an error if emojis are found
      }
      return null; // return null if no emojis are found
    };
  }

  getSupportData(value: any) {
    const params = {
      country_id : value
    };
    this.api('post', 'get_support_data', this.mainService.urlParams(params))
      .subscribe((data: any) => {
        localStorage.setItem('supportData', JSON.stringify(data.support_data));
        this.mainService.support_data = data.support_data;
      });
  }

}

class customQueryEncoder {
  encodeKey(k: string): string {
    return this.encode(k);
  }
  encodeValue(v: string): string {
    return this.encode(v);
  }

  private encode(v: string): string {
    return encodeURIComponent(v)
    .replace(/%40/gi, '@')
    .replace(/%7B/gi, '{')
    .replace(/%7D/gi, '}')
    .replace(/%22/gi, '"')
    .replace(/%20/gi, " ")
    .replace(/%7C/gi, "|")
    .replace(/%3A/gi, ":")
    .replace(/%24/gi, "$")
    .replace(/%2C/gi, ",")
    .replace(/%3B/gi, ";")
    .replace(/%2B/gi, '+')
    .replace(/%3D/gi, ";")
    .replace(/%3F/gi, "?")
    .replace(/%2F/gi, "/")
  }

}